import React from 'react';
import { ThemeToggle } from './ThemeToggle';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { copy } from '../copy';
interface HeaderProps {
  title?: string;
  subtitle?: string;
  showProjectLink?: boolean;
  showBackArrow?: boolean;
  backTo?: string;
  minimal?: boolean;
}
export function Header({
  title = copy.brand.name,
  subtitle,
  showProjectLink = true,
  showBackArrow = false,
  backTo = '/case',
  minimal = false
}: HeaderProps) {
  const navigate = useNavigate();
  return <header className="sticky top-0 z-10 flex h-14 items-center justify-between border-b border-slate-200 dark:border-[#333] bg-white/80 dark:bg-[#1a1a1a]/80 px-4 backdrop-blur-md" data-id="element-222">
      <div className="flex items-center gap-4" data-id="element-223">
        {showBackArrow && <button onClick={() => navigate(backTo)} className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-white/5 text-slate-500 dark:text-[#a3a3a3] transition-colors" data-id="element-224">
            <ArrowLeft size={20} data-id="element-225" />
          </button>}
        {minimal ? <div className="flex items-center gap-2" data-id="element-226">
            {title === copy.brand.name && <img src="https://cdn.magicpatterns.com/uploads/wBrpemDYzZmjFSuxiYRjhJ/Imperian.png" alt="Imperian Logo" className="h-6 w-auto" data-id="element-227" />}
            <span className="font-semibold text-slate-900 dark:text-white" data-id="element-228">
              {title}
            </span>
          </div> : <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/cases')} data-id="element-229">
            <img src="https://cdn.magicpatterns.com/uploads/wBrpemDYzZmjFSuxiYRjhJ/Imperian.png" alt="Imperian Logo" className="h-6 w-auto" data-id="element-230" />
            <span className="font-semibold text-slate-900 dark:text-white" data-id="element-231">
              {title}
            </span>
          </div>}
      </div>
      <div className="flex items-center gap-2" data-id="element-232">
        {!minimal && <>
            <button onClick={() => navigate('/cases')} className="rounded-md px-3 py-1.5 text-sm font-medium text-slate-600 dark:text-[#a3a3a3] hover:bg-slate-100 dark:hover:bg-white/5" data-id="element-233">
              {copy.header.casesLink}
            </button>
            {showProjectLink && <button onClick={() => navigate('/case')} className="rounded-md px-3 py-1.5 text-sm font-medium text-slate-600 dark:text-[#a3a3a3] hover:bg-slate-100 dark:hover:bg-white/5" data-id="element-234">
                {copy.header.caseDetailLink}
              </button>}
            <div className="w-px h-4 bg-slate-200 dark:bg-[#333] mx-1" data-id="element-235" />
          </>}
        <ThemeToggle data-id="element-236" />
      </div>
    </header>;
}